import { render, staticRenderFns } from "./Spinner.vue?vue&type=template&id=0e5a540e&scoped=true"
import script from "./Spinner.vue?vue&type=script&lang=js"
export * from "./Spinner.vue?vue&type=script&lang=js"
import style0 from "./Spinner.vue?vue&type=style&index=0&id=0e5a540e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e5a540e",
  null
  
)

export default component.exports